import * as React from 'react';

import * as styles from './ReviewsFixedFooterLayout.css';

interface IReviewsFixedFooterLayout {
  review: React.ReactElement;
  question: React.ReactElement;
  moderation: React.ReactElement;
}
export const ReviewsFixedFooterLayout: React.FC<IReviewsFixedFooterLayout> = ({ review, question, moderation }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['item']}>{review}</div>
      <div className={styles['item']}>{question}</div>
      <div className={styles['link']}>{moderation}</div>
    </div>
  );
};
